module.exports = __webpack_public_path__ + "img/flip_horiz.9bdd89d6.svg";